/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PutUserRequestsIdMutationRequest,
  PutUserRequestsIdMutationResponse,
  PutUserRequestsIdPathParams,
  PutUserRequestsId400,
} from '../entities/PutUserRequestsId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { putUserRequestsId } from '../api/putUserRequestsId'
import { useMutation } from '@tanstack/react-query'

export const putUserRequestsIdMutationKey = () => [{ url: '/user-requests/{id}' }] as const

export type PutUserRequestsIdMutationKey = ReturnType<typeof putUserRequestsIdMutationKey>

/**
 * @description Обновление заявки водителя таксопарка
 * @summary Обновление заявки водителя таксопарка
 * {@link /user-requests/:id}
 */
export function usePutUserRequestsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutUserRequestsIdMutationResponse,
      ResponseErrorConfig<PutUserRequestsId400>,
      { id: PutUserRequestsIdPathParams['id']; data: PutUserRequestsIdMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<PutUserRequestsIdMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? putUserRequestsIdMutationKey()

  return useMutation<
    PutUserRequestsIdMutationResponse,
    ResponseErrorConfig<PutUserRequestsId400>,
    { id: PutUserRequestsIdPathParams['id']; data: PutUserRequestsIdMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putUserRequestsId(id, data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}